/**
 * 管理端「美团直连」模块是否启用（与后端 meituan.admin-dev-ui.enabled、构建环境一致）。
 * dev 构建为 true；生产构建为 false。
 */
export function isMeituanDevUiEnabled() {
  return process.env.VUE_APP_MEITUAN_DEV_UI === 'true';
}



// WEBPACK FOOTER //
// ./src/utils/meituanDevFeature.js